export default "/_next/static/c4e2d96c010ac9532606fde94323894b.png";